/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const getOrderBuildWeekData = params => {

    const buildWeekData = formatGivenDate( params.data.buildWeek, 'YYYY-MM-DD' );
    if ( buildWeekData === '2000-01-01' ) return 'Inventory';
    if ( buildWeekData === '2000-02-01' ) return 'Rework';

    return buildWeekData;

};

const colDefs = [

    {
        field: 'effectiveFamily',
        headerName: 'Family',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: true,
        filter: true,
        width: 80,
        cellRenderer: params => ( <Link to={`/${params.data.unitName}/order/information?ordernum=${params.data.orderNumber}`}>{params.value}</Link> )
    },
    {
        field: 'orderStatus',
        headerName: 'Order Status',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'creditCode',
        headerName: 'Credit Code',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'linkedOrderInd',
        headerName: 'Linked Order Ind',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'buildWeek',
        headerName: 'Order Build Week',
        sortable: true,
        filter: true,
        width: 80,
        valueGetter: getOrderBuildWeekData
    }
];

const OrderAvailableToShipTable = props => (

    <section className="atp-search-result-panel order-available-to-ship-result-panel ">

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

OrderAvailableToShipTable.propTypes = {
    results: PropTypes.array.isRequired,
    time: PropTypes.number
};
export default OrderAvailableToShipTable;
